export const CEP_SETUP_GET_SITES = 'CEP_SETUP_GET_SITES';
export const CEP_SETUP_LOADING = 'CEP_SETUP_LOADING';
export const CEP_SETUP_ERRORS = 'CEP_SETUP_ERRORS';
export const CEP_SETUP_GET_IDENTIFIED_STUDENTS =
  'CEP_SETUP_GET_IDENTIFIED_STUDENTS';
export const CEP_SETUP_GET_SITES_BY_FISCAL_YEAR =
  'CEP_SETUP_GET_SITES_BY_FISCAL_YEAR';
export const CEP_SETUP_GET_FISCAL_YEARS = 'CEP_SETUP_GET_FISCAL_YEARS';
export const CEP_SETUP_LOAD_SITES = 'CEP_SETUP_LOAD_SITES';



// WEBPACK FOOTER //
// ./src/pages/cepsetup/state/setup/types.js